<template>
 <el-container class="flex flex-row h-full w-full">
  <el-row class="flex flex-col bg-[#F3F5F7]" :style="{ boxShadow: '9px 7px 10px -8px rgba(75,112,140,0.25)' }">
    <div class="bg-no-repeat bg-cover m-w-[200px] h-[60px] bg-transparent flex justify-center items-center cursor-pointer" 
    :style="{ backgroundImage: `url(${isMenuCollapse? '/images/bst-small.png' : '/images/bst.png'})`, 
    backgroundSize: 'contain' , backgroundPosition: 'center'}" @click="goHome()">
    </div>

    <el-row class="flex-1 overflow-x-auto border-b border-solid border-[#383838]">
      <el-menu :default-active="mainMenuItem" class="control-menu" :collapse="isMenuCollapse" :collapse-transition=false>
        <el-menu-item index="workspace" class="control-menu-item" :style="{padding: isMenuCollapse?'0 0 0 20px':'0 50px'}" @click="handleMainMenu('workspace')">
          <i class="el-icon-menu"></i>
          <span>工作台</span>
        </el-menu-item>
        <!-- <el-menu-item index="dempartment" class="control-menu-item" :style="{ padding: isMenuCollapse?'0 0 0 20px':'0 50px'}" @click="handleMainMenu('department')">
          <i class="el-icon-document"></i>
          <span :class="[isMenuCollapse?'hidden':'visible']">部门管理</span>
        </el-menu-item> -->
        <!-- <el-menu-item index="role" class="control-menu-item" :style="{ padding: isMenuCollapse?'0 0 0 20px':'0 50px'}" @click="handleMainMenu('role')">
          <i class="el-icon-s-check"></i>
          <span :class="[isMenuCollapse?'hidden':'visible']">角色管理</span>
        </el-menu-item> -->
        <el-menu-item index="staff" class="control-menu-item" :style="{padding: isMenuCollapse?'0 0 0 20px':'0 50px'}" @click="handleMainMenu('staff')" v-if="profile.orgId != ''">
          <i class="el-icon-user"></i>
          <span :class="[isMenuCollapse?'hidden':'visible']">人员管理</span>
        </el-menu-item>

        <!-- <el-menu-item index="invitation" class="control-menu-item" :style="{ padding: isMenuCollapse?'0 0 0 20px':'0 50px'}" @click="handleMainMenu('invitation')">
          <i class="el-icon-microphone"></i>
          <span :class="[isMenuCollapse?'hidden':'visible']">邀请人员</span>
        </el-menu-item> 
        
        <el-menu-item index="auth-app" class="control-menu-item" :style="{ padding: isMenuCollapse?'0 0 0 20px':'0 50px'}" @click="authApp()">
          <i class="el-icon-office-building"></i>
          <span>授权应用</span>
        </el-menu-item> -->

        <el-menu-item index="manage-org-seal" class="control-menu-item" :style="{ padding: isMenuCollapse?'0 0 0 20px':'0 50px'}" @click="manageOrgSeal()" v-if="profile.orgId != ''">
          <i class="el-icon-office-building"></i>
          <span>机构印章</span>
        </el-menu-item>
        <el-menu-item index="manage-psn-seal" class="control-menu-item" :style="{ padding: isMenuCollapse?'0 0 0 20px':'0 50px'}" @click="managePsnSeal()">
          <i class="el-icon-s-check"></i>
          <span>个人印章</span>
        </el-menu-item>
        <el-menu-item index="blockchain" class="control-menu-item" :style="{ padding: isMenuCollapse?'0 0 0 20px':'0 50px'}" @click="handleMainMenu('servicePack')">
          <i class="el-icon-bank-card"></i>
          <span>服务包</span>
        </el-menu-item>
        <!-- <el-menu-item index="blockchain" class="control-menu-item" :style="{ padding: isMenuCollapse?'0 0 0 20px':'0 50px'}" @click="handleMainMenu('blockchain')">
          <i class="el-icon-setting"></i>
          <span>区块链存证</span>
        </el-menu-item> -->
      </el-menu>
    </el-row>
    
    <el-row class="text-center h-[40px] ">
      <span class="close-menu" @click="showControl()">
      {{ isMenuCollapse ? '>>' : '<<&nbsp;&nbsp;收起侧栏' }}
      </span>
    </el-row>
  </el-row>

  <el-container class="flex-1 flex flex-col h-full w-full">
    <el-header class="flex row relative bg-[#F3F5F7] min-w-[260px] border-t border-solid border-white">
      <!-- <div class="flex-none leading-[50px] ml-[20px] text-blue-500" style="font-size:22px">E链签</div> -->
      <div class="flex-1 flex flex-row items-center h-[50px]">
        <div class="flex-1 text-center">
            <el-select v-model="profile.orgId" ref="orgSelect" class="font-bold  w-[375px]" @change="handleOrgChange(profile.orgId)">
              <el-option key="0" :label="profile.userName + '的个人空间'" value="">
              </el-option>
              <el-option
                v-for="(item, index) in organizations" :key="index+1" :label="item.name" :value="item.orgId">
              </el-option>
              <div class="flex flex-row justify-center my-[10px]">
                <el-button @click="handleAddOrg()" type="primary">加入/创建机构</el-button>
              </div>
            </el-select>
          <!-- <el-dropdown @command="handleOrganizations" v-show="profile.orgId != 0">
            <span  class="text-black bg-[#e7e8ea] whitespace-nowrap overflow-hidden overflow-ellipsis rounded-lg text-sm py-[8px] px-[20px]">{{profile.orgName}}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="org in organizations" :key="org.id" :icon="org.id == profile.orgId ? 'el-icon-check' : ''" class="font-bold" :command="org.id">{{ org.name }}</el-dropdown-item>
              <el-dropdown-item >添加机构或者企业</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->
        </div>
        <div class="text-center text-2xl overflow-hidden whitespace-nowrap">
          <!-- <el-menu mode="horizontal" text-color="#000" active-text-color="#ffd04b">
            <el-menu-item index="2">处理中心</el-menu-item>
            <el-menu-item index="3">消息中心</el-menu-item>
            <el-menu-item index="4">订单管理</el-menu-item>
          </el-menu>  -->
        </div>
        
        <div class="flex-end flex flex-row items-center justify-center">
          <!-- <img src="/images/language.png" class="w-[16px] h-[16px] mr-[10px]"/> -->
          <el-button type="primary" @click="logout()">登出</el-button>
        </div>
      </div>
    </el-header>
    <el-main class="flex-1 bg-[#F3F5F7]" >
      <Flow v-if="mainMenuItem === 'workspace'" :profile=profile></Flow>
      <Staff v-if="mainMenuItem === 'staff'" :profile=profile></Staff>
      <Role v-if="mainMenuItem === 'role'" :profile=profile></Role>
      <Invitation v-if="mainMenuItem === 'invitation'" :profile=profile></Invitation>
      <Department v-if="mainMenuItem === 'department'" :profile=profile></Department>
      <ServicePack v-if="mainMenuItem === 'servicePack'" :profile=profile></ServicePack>
      <BlockChain v-if="mainMenuItem === 'blockchain'" :profile=profile></BlockChain>
    </el-main>
  </el-container>
  <el-dialog title="加入/创建企业" :visible.sync="dialogAddOrgVisible" :close-on-click-modal="false" :before-close="closeDialogBefore" width="375px">
    <div class="flex flex-col">
      <span class="mb-2">请输入您要加入或者创建的企业名称，并确保与营业执照上的名称一致。</span>
      <span class="text-[#e63740]"><i class="el-icon-info"></i>&nbsp;&nbsp;如果输入的企业名称未注册，那么将会创建该企业。实名认证后，您将自动成为该企业管理员，并生成对应企业名称的公章。</span>
    </div>
    <el-input type="textarea" :rows="2" v-model="orgNameSearch" placeholder="请输入企业名称" class="pt-[20px] pb-[10px]"></el-input>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancelDialogAddOrg()">取 消</el-button>
      <el-button type="primary" @click="okDialogAddOrg()">确 定</el-button>
    </span>
</el-dialog>
</el-container>
</template>

<script>
import { 
  fetchOrganizations, 
  fetchManageOrgSeal,
  fetchManagePsnSeal,
  fetchPsnAuthSeal,
  fetchOrgAuthUrl,
  fetchSwitchWorkspace
} from '@/api/api';

import Flow from './Flow.vue'
import Role from './Role.vue'
import Staff from './Staff.vue'
import Invitation from './Invitation.vue'
import Department from './Department.vue'
import ServicePack from './ServicePack.vue'
import BlockChain from './BlockChain.vue'


export default {
  name: 'HomePage',
  components: {
    'Flow': Flow,
    'Staff':Staff,
    'Invitation':Invitation,
    'Department':Department,
    'Role':Role,
    'ServicePack': ServicePack,
    'BlockChain':BlockChain,
  },
  
  data(){
    return {
      profile: {
        userId: "0",
        orgId: "",
        userName: "",
        orgName: "",
        psnId: "",
      },
      organizations:[],
      mainMenuItem: "workspace",
      isMenuCollapse: false,
      hideControl: false,

      dialogAddOrgVisible: false,
      orgNameSearch: "",      
    }
  },
  async mounted() {
    this.mainMenuItem = localStorage.getItem("mainMenuItem")||"workspace"

    this.profile.psnId = localStorage.getItem("psnId")||""
    this.profile.userId = localStorage.getItem("uid")||"0"
    if (this.profile.userId === "0") {
      this.$router.push('/');
      return
    }
    this.profile.userName = localStorage.getItem("uname")||""
    this.profile.orgId = localStorage.getItem("orgId")||""
    this.profile.orgName = localStorage.getItem("orgName")||""

    try {
      let result = await fetchOrganizations(this.profile.userId);
      // console.log(result, "查询用户所属企业")
      if (result.data.code == 0) {
        result.data.data.forEach(element => {
          let item = {}
          item.orgId = element.orgId
          item.name = element.name
          item.id = element.id
          // console.log(item, "用户所属每个企业")
          this.organizations.push(item)
        });
      }
    }catch(err){
      console.log(err);
      this.profile.orgId = "";
    }
  },
  methods: {
    
    handleAddOrg() {
      this.$refs.orgSelect.visible = false;
      this.dialogAddOrgVisible = true;
    },

    async handleOrgChange(orgId){
      var params = {};
      if (orgId == "") {
        this.profile.orgId = "";
        this.profile.orgName = "个人空间";

        localStorage.setItem('RemainingNumId', "");
        localStorage.setItem('orgId', this.profile.orgId);
        localStorage.setItem('orgName', this.profile.orgName);
        params = {
					"orgId": ""
				}
      } 
      else {
        this.profile.orgName = "";
        this.organizations.forEach(element => {
          if (element.orgId == orgId) {
            this.profile.orgName = element.name;
            this.profile.orgId = element.orgId;

            localStorage.setItem('RemainingNumId', element.id);
            localStorage.setItem('orgId', element.orgId);
            localStorage.setItem('orgName', element.name);

            params = {
              "orgId": this.profile.orgId
            }
            return;
          }
        });
      }

      try {
          let result = await fetchSwitchWorkspace(params);
          if (result.data.code != 0) {
            this.$message.error("请稍候再试");
            return;
          }else {
            this.$router.go(0);
            return true;
          }
        } catch (e){
          console.error("错误信息：", e);
          this.$message.error("无法登录系统");
        }
    },

    showControl() {
      this.isMenuCollapse = !this.isMenuCollapse;
    },

    logout() {
      localStorage.setItem("mainMenuItem", "workspace")
      localStorage.setItem("uid", "")
      localStorage.setItem("uname", "")
      localStorage.setItem("oid", "")
      localStorage.setItem('token', "");
      localStorage.setItem('orgId', "");
      localStorage.setItem('orgName', "个人空间");
      this.$router.push('/');
    },

    handleMainMenu(key) {
      this.mainMenuItem = key;
      localStorage.setItem('mainMenuItem', this.mainMenuItem);
    },
    
    handleOrganizations(command) {
      if (command != this.profile.orgId) {
        let that = this
        this.profile.orgId = parseInt(command)
        this.organizations.forEach(
        element => {
          if (element.id == that.profile.orgId) {
            that.profile.orgName = element.name
            return
          }
        }
      )
      } 
    }, 

    async manageOrgSeal(){
      const raw = JSON.stringify({
        "orgId": this.profile.orgId,
        "transactorPsnId": this.profile.psnId
      });
      try {
        let result = await fetchManageOrgSeal(raw);
        // console.log(result,"机构印章管理")

          if (result.data.code !== 0) {
            console.error("错误信息：", result.data.data.message);
            this.$message.error("无法管理机构印章，请稍候再试");
            return;
          }
          else if (result.data.data.code != 0) {
            this.$message.error(result.data.data.message);
            return;
          }
          else if (!result.data.data.data) {
            console.error("错误信息：", "返回的链接为空");
            this.$message.error("无法管理机构印章，请稍候再试");
            return;
          }else {
            window.open(`/frame-seal-psn?url=${encodeURIComponent(result.data.data.data.orgSealManageUrl)}`,"_blank");
            return true;
          }
      } catch (e){
        console.error("错误信息：", e);
        this.$message.error("无法登录系统");
      }
    },

    async managePsnSeal() {
      const raw = JSON.stringify({
        "psnId": this.profile.psnId,
      });
      try {
        let result = await fetchManagePsnSeal(raw);
        // console.log(result,"个人印章管理")

          if (result.data.code !== 0) {
            console.error("错误信息：", result.data.data.message);
            this.$message.error("无法管理个人印章，请稍候再试");
            return;
          }
          else if (result.data.data.code != 0) {
            this.$message.error(result.data.data.message);
            return;
          }
          else if (!result.data.data.data) {
            console.error("错误信息：", "返回的链接为空");
            this.$message.error("无法管理个人印章，请稍候再试");
            return;
          }else {
            window.open(`/frame-seal-psn?url=${encodeURIComponent(result.data.data.data.psnSealManageUrl)}`,"_blank");
            return true;
          }
      } catch (e){
        console.error("错误信息：", e);
        this.$message.error("无法登录系统");
      }
    },

    authApp(){
      fetchPsnAuthSeal().then(result => {
        if (!result.data) {
          console.error("no psn seal data")
          return
        }

        if (result.data.code != 0) {
          console.error(result.data.message)
          return
        }
      
        if (!result.data.data) {
          console.error("no url")
          return
        }
        window.open(`/frame?url=${encodeURIComponent(result.data.data)}`, "_blank");
    }).catch(err => {
      console.log(err)
      })
    },

    cancelDialogAddOrg() {
      this.dialogAddOrgVisible = false;
      this.orgNameSearch = "";
    },

    okDialogAddOrg() {
      var params = {
					"authorizeConfig": {
						"authorizedScopes": []
					},
					"clientType": "",
					"noticeTypes": "",
					"notifyUrl": "",
					"orgAuthConfig": {
						"orgAuthPageConfig": {
							"orgAvailableAuthModes": [],
							"orgDefaultAuthMode": "",
							"orgEditableFields": []
						},
						"transactorAuthPageConfig": {
							"psnAvailableAuthModes": [],
							"psnDefaultAuthMode": "",
							"psnEditableFields": []
						},
						"transactorInfo": {
							"psnAccount": "",
							"psnId": "",
							"psnInfo": {
								"bankCardNum": "",
								"psnIDCardNum": "",
								"psnIDCardType": "",
								"psnMobile": "",
								"psnName": ""
							}
						},
						"orgId": "",
						"orgInfo": {
							"legalRepIDCardNum": "",
							"legalRepIDCardType": "",
							"legalRepName": "",
							"orgIDCardNum": "",
							"orgIDCardType": "",
							"orgType": ""
						},
						"orgName": this.orgNameSearch
					},
					"orgAuthPageConfig": {},
					"redirectConfig": {
						"appScheme": "",
						"redirectDelayTime": 0,
						"redirectUrl": "https://econtract.top/home"
					}
				}

      fetchOrgAuthUrl(params).then(result => {
        if (!result.data) {
          console.error("no org seal data")
          return
        }

        if (result.data.code != 0) {
          console.error(result.data.message)
          return
        }
      
        if (!result.data.data.authUrl) {
          console.error("no url")
          return
        }
        window.open(`/frame?url=${encodeURIComponent(result.data.data.authUrl)}`, "_blank");
    }).catch(err => {
      console.log(err)
      })
    },

    closeDialogBefore() {
      this.dialogAddOrgVisible = false;
      this.orgNameSearch = "";
    },

    goHome(){
      window.location = "/";
    },
  },
}
</script>

<style scoped>
.control-menu{
  border-right: none;
  margin:20px 0;
  padding: 0 0;
  background-color: #F3F5F7;
}
.control-menu-item {
  color: #383838!important;
  height: 60px;
  line-height: 60px;
  margin: 0 0;
}
.control-menu-item:hover,
.control-menu-item:active,
.control-menu-item.is-active {
  background-color: #E9EFFF !important;
  color: #4D7DFF !important;
  /* border-radius: 10px; */
}

.control-menu-item:hover,
.control-menu-item:active,
.control-menu-item.is-active {
  background-color: #E9EFFF !important;
  color: #4D7DFF !important;
  /* border-radius: 10px; */
}
.close-menu {
  line-height: 40px;
  color:#383838;
  font-size:14px;
  cursor: pointer;
}
.close-menu:hover {
  color: #4D7DFF !important;
}

/deep/.el-button {
padding-top: 8px;
padding-bottom: 8px;
}

/* 为所有滚动条设置样式 */
::-webkit-scrollbar {
  width: 8px; /* 设置滚动条的宽度 */
  height: 10px; /* 设置滚动条的高度 */
}

/* 滚动条轨道 */
::-webkit-scrollbar-track {
  background: #f8f8f8; /* 设置轨道的背景颜色 */
}

/* 滚动条的滑块 */
::-webkit-scrollbar-thumb {
  background: rgba(56, 56, 56, 0.5); /* 设置滑块的背景颜色 */
  border-radius: 20px 20px;
}

/* 当鼠标悬停在滑块上 */
::-webkit-scrollbar-thumb:hover {
  background: #555; /* 设置滑块在悬停状态下的背景颜色 */
  cursor: pointer;
}
</style>